import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MaskService } from 'src/app/services/mask.service';
import {
  WellnessWorkOrder,
  WorkWorkOrder,
  QuoteWorkOrder,
  WorkOrderPriceAdjustment,
  WellnessWorkOrderCashCollected,
  WorkWorkOrderCashCollected,
  PriceAdjustment} from '../../services_autogenerated/generated_services';
import { ControlContainer, NgForm } from '@angular/forms';
import { WorkOrderHelperService } from 'src/app/services/work-order-helper.service';
import { AuthHelperService } from 'src/app/services/auth-helper.service';

@Component({
    selector: 'app-work-order-maintenance-common-fields-bottom',
    templateUrl: './work-order-maintenance-common-fields-bottom.component.html',
    styleUrls: ['./work-order-maintenance-common-fields-bottom.component.css'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }] // Gets the form from the parent
    // Sourced from https://medium.com/@a.yurich.zuev/angular-nested-template-driven-form-4a3de2042475
    ,
    standalone: false
})
export class WorkOrderMaintenanceCommonFieldsBottomComponent implements OnInit {
  @Input() workOrder: WellnessWorkOrder | WorkWorkOrder | QuoteWorkOrder;
  @Input() isEditable: boolean;
  @Input() isCustomer: boolean;
  @Input() canCompleteWO: boolean;
  @Input() hidePrice: boolean;
  @Input() isQuote = false;
  thing = true;
  cashIndex = 0;

  canCollectCash: boolean;
  canSeePrice: boolean;
  stage: string;
  cashCollected: WellnessWorkOrderCashCollected[] | WorkWorkOrderCashCollected[] = [];
  paymentInfoRequired = true;

  @Output() priceAdjustmentDeleted = new EventEmitter<WorkOrderPriceAdjustment>();

  claimNames: any;
  userId?: number;

  constructor(
    public helper: WorkOrderHelperService,
    private authHelper: AuthHelperService
  ) { }

  ngOnInit() {
    this.paymentInfoRequired = this.workOrder.customer.paymentInfoRequired;
    if (!this.paymentInfoRequired) {
      this.workOrder.autoChargeEnabled = false;
    }
    
    if (this.workOrder instanceof QuoteWorkOrder) {
      this.stage = 'quote';
    } else {
      this.stage = 'work order';
    }
    const token = this.authHelper.getDecodedAccessToken();
    this.userId = token.id;
    this.claimNames = token.claimNames;
    this.canCollectCash = this.claimNames.includes('Completing a Task');
    this.canSeePrice = !this.hidePrice ||  this.claimNames.includes('View Hidden Prices');
  }

  public toFixed = (value: unknown): string => {
      return this.helper.currencyRound(value).toString();
    }
    
  addPriceAdjustment() {
    const wopa = new WorkOrderPriceAdjustment();
    wopa.priceAdjustment = new PriceAdjustment();
    wopa.priceAdjustment.active = true;
    this.workOrder.workOrderPriceAdjustments.push(wopa);
  }

  hasCustomerMaintenancePermissions() {
    return this.claimNames.includes('View/Edit Customer Maint.');
  }

  deletePriceAdjustment(wopa: WorkOrderPriceAdjustment) {
    this.priceAdjustmentDeleted.emit(wopa);
  }

  cashCollectedChange(newValue: number, index: number) {
    if (newValue) {
      this.workOrder['workOrderCashCollected'][index].amount = newValue;
      this.workOrder['workOrderCashCollected'][index].collectedBy = this.userId;
    } else {
      this.workOrder['workOrderCashCollected'][index].amount = 0;
      this.workOrder['workOrderCashCollected'][index].collectedBy = this.userId;
    }
  }

  removeCashCollectedEntry(index) {
    this.workOrder['workOrderCashCollected'].splice(index, 1);
  }

  // I don't really like this work around
  // But Quotes do not have a property that is needed for Work Orders
  // So pass the variable back as a WO to get at that property
  asWorkOrderNotQuote() {
    return this.workOrder as WellnessWorkOrder | WorkWorkOrder;
  }

  isCashCollectedEditable() {
    return this.canCollectCash && this.isEditable;
  }
}
